<template lang="pug">
    .component-transaction-controller
        transaction(:item="item",:type="'detail'")
</template>
<script type="text/babel">
    import Client from 'components/backoffice/Client'
    import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
    import Transaction from "../../../components/backoffice/Transaction";

    export default{
        name: "TransactionController",
        components: {
            Transaction,
            Client
        },
        data(){
            return {
                client: null
            }
        },
        created() {

        },
        methods: {},
        computed: {},
        props: ['item'],

    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// Transaction.vue?5e87881a